/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Tab_ActiveInputs */

const en_settings_billing_tab_active = /** @type {(inputs: Settings_Billing_Tab_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const zh_settings_billing_tab_active = /** @type {(inputs: Settings_Billing_Tab_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活跃`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Settings_Billing_Tab_ActiveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_tab_active = /** @type {((inputs?: Settings_Billing_Tab_ActiveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Tab_ActiveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_tab_active(inputs)
	return zh_settings_billing_tab_active(inputs)
});
export { settings_billing_tab_active as "settings.billing.tab_active" }